/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
import ImgPoint from '../../../../../assets/animation_point.gif';

import './animation025.less';

interface IAnimation025Item {
  text: string;
  title: string;
  color: string;
}

interface IAnimation025Props {
  items: IAnimation025Item[];
  className?: string;
  onCompleted?: () => void;
}

const Animation025: React.FunctionComponent<IAnimation025Props> = ({
  items,
  className,
  onCompleted,
}) => {
  const [play, setPlay] = React.useState(1);
  const [isPlayed, setIsPlayed] = React.useState(false);
  const startPlay = (next = 1) => {
    if (isPlayed) {
      return;
    }
    next += 1;
    setPlay(next);
    setIsPlayed(true);
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1000);
    } else {
      console.log('Animation021 onCompleted');
      onCompleted && onCompleted();
    }
  };
  return (
    <div className={`animation025 component ${className || ''}`}>
      {items.map((itm: IAnimation025Item, idx: number) => (
        <div
          key={idx}
          className={`animation025-item animation ${
            play >= idx + 1 ? 'fade-in' : ''
          }`}
          onClick={() => startPlay()}
        >
          <img
            className={`click-point ${play > 1 ? 'hide' : ''}`}
            src={ImgPoint}
            alt=""
          />
          <div
            className="animation025-color-div"
            style={{ backgroundColor: itm.color }}
          />
          <div className="animation025-gray-div" />
          <div
            className="animation025-title"
            dangerouslySetInnerHTML={{ __html: itm.title }}
            style={{ backgroundColor: itm.color }}
          />
          <div
            className="animation025-text"
            dangerouslySetInnerHTML={{ __html: itm.text }}
          />
          <div
            className="animation025-color-div"
            style={{ backgroundColor: itm.color }}
          />
        </div>
      ))}
    </div>
  );
};

export default Animation025;
